import { create } from "zustand"

/**
 * Minimal chat store — only exists for storeManager.clearAllData() compatibility.
 * The actual AI chat functionality uses direct API calls (SectionChatPanel, EnhancedAIAssistant).
 */
interface ChatStore {
	clearAllData: () => void
}

export const useChatStore = create<ChatStore>()(() => ({
	clearAllData: () => {
		if (typeof window !== "undefined") {
			localStorage.removeItem("chat-store")
		}
	},
}))
